import { Link, Navigate } from "react-router";
import { formatPhone } from "../../shared/phone.ts";
import { useT } from "../lib/i18n.tsx";
import { useMe } from "../lib/me.tsx";

/** Placeholder hub until T1.5 (settings) and Phase 3 (purchases/sales) land. */
export function MePage() {
  const t = useT();
  const { me, loading, logout } = useMe();
  if (loading) return <div className="page muted">{t("common.loading")}</div>;
  if (!me) return <Navigate to="/login?next=/me" replace />;
  return (
    <div className="page page--narrow">
      <h1 className="h1" data-testid="me-name">
        {me.display_name || me.handle}
      </h1>
      <p className="muted">
        @{me.handle} · {me.phone ? formatPhone(me.phone) : ""}
      </p>
      <div className="stack">
        <Link className="btn" to="/me/settings">
          {t("nav.settings")}
        </Link>
        <button className="btn btn--ghost" onClick={() => void logout()} data-testid="logout">
          {t("nav.logout")}
        </button>
      </div>
    </div>
  );
}
